export class FaxLockInfo {
    faxId!: string;
    userName!: string;
    displayName!: string;
    lockDate!: string;
}